var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.preview ? 'div' : 'textarea',_vm._g(_vm._b({tag:"component",staticClass:"input-textarea",class:{'input-textarea--preview': _vm.preview, 'input-textarea--error': _vm.error},attrs:{"value":_vm.value,"autocomplete":"off"}},'component',_vm.$attrs,false),{
    ..._vm.$listeners,
    input: (e) => _vm.$emit('input', e.target.value),
  }),[_vm._v(_vm._s(_vm.value))])
}
var staticRenderFns = []

export { render, staticRenderFns }